module.exports = __webpack_public_path__ + "static/records-download-audit-log-c2148122d936bd2671d6ff85cec9623a.png";